import BadgeHome from '@/screens/BadgeHome';

export default function PrivateTabsOrganizationBadgeRoute() {
  return <BadgeHome />;
}
